import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lemonSqueezy = defineConnector({
  identifier: "lemonSqueezy",
  name: "Lemon Squeezy",
  tagLine: "Payments and subscriptions for software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.lemonsqueezy\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Lemon Squeezy](https://app.lemonsqueezy.com/settings/api), open **Settings › API** and create a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.lemonsqueezy.com/v1/users/me",
      headers: { Accept: "application/vnd.api+json" },
    }),
  },
});
